import React from 'react'
import { motion } from 'framer-motion'
import AppKarmaSectionLeftImage from '../Images/MomoKarmaImages/AppKarmaSectionLeftImage.svg'
import AppKarmaQRcode from '../Images/AppKarmaQrCode.svg'
import Googleplay from '../Images/ImgGooglePlay.svg'
import VisitWebApp from '../Images/ImgVisitWebapp.svg'

import { Image } from '@nextui-org/react'
export default function AppKarmaSection({ appKarmaRef }) {
  const content = {
    title: (
      <div>
        <div
          className="xl:text-[40px] lg:text-4xl text-3xl font-bold tracking-normal font-mulish"
        >
          <div className="">
            <span className="text-[#38D169]">AppKarma</span> - Free Cash, Gift Cards, Scratchers
          </div>
        </div>
      </div>
    ),
    leftSide: (
      <div className="lg:my-4 my-2">
        <div>
          <p className="text-wrap xl:text-xl text-lg font-semibold leading-relaxed text-gray-800">
            AppKarma brings you the biggest collection of mobile games — from casual merge games to intense strategy battles.
          </p>

          <p className="text-wrap xl:text-lg mt-4 leading-relaxed text-gray-600">
            Play top-rated titles, complete missions, and earn free gift cards from Amazon, Google Play, iTunes, and more. It's the ultimate way to turn game time into reward time.
          </p>
        </div>
        <div className="lg:mt-7 mt-3 flex items-center">
          <div className="hidden lg:flex flex-col items-center justify-center p-4">
            <Image
              src={AppKarmaQRcode}
              alt="AppKarmaQrCode"
              width={'190'}
              height={'190'}
            />
            <p className="text-center text-sm font-medium text-gray-700 mt-2">Scan QR Code for BONUS</p>
          </div>
          <div className="lg:block flex lg:gap-0 gap-2 lg:mt-0 mt-4">
            <a 
              href="https://play.google.com/store/apps/details?id=com.appkarma.app"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                className="lg:my-2 my-0"
                src={Googleplay}
                alt="GooglePlayIcon"
                width={'193'}
                height={'54'}
              />
            </a>
            <a 
              href="https://app.appkarma.io"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Image
                src={VisitWebApp}
                alt="VisitWebappIcon"
                width={'193'}
                height={'54'}
              />
            </a>
          </div>
        </div>
      </div>
    ),
    rightSide: (
      <div className="w-full">
        <Image
          src={AppKarmaSectionLeftImage}
          alt="About Image"
          width={'624'}
          height={'624'}
        />
      </div>
    ),
  }

  return (
    <div
      ref={appKarmaRef}
      id="appkarma_page"
      className="lg:px-10 px-2 h-screen bg-[#EEFBF2] rounded-lg flex flex-col justify-center md:flex-row lg:container mx-auto snap-start w-screen h-screen"
      style={
        {
          // background:
          //   "radial-gradient(50.00% 50.00% at 50% 50.00%, #686868 0%, #585858 100%)",
        }
      }
    >
      <motion.div
        initial={{ x: -100 }}
        animate={{ x: 0 }}
        transition={{ type: 'spring', stiffness: 100, duration: 2 }}
        className="md:w-1/2 flex items-center justify-center p-4"
      >
        <div className="w-full">
          <div>{content.title}</div>
          <div className=" mg:mt-4 mt-2 text-slate-700">{content.leftSide}</div>
        </div>
      </motion.div>
      <div className="md:w-1/2 flex items-center justify-center p-4">
        <motion.div
          initial={{ x: 100 }}
          animate={{ x: 0 }}
          transition={{ type: 'spring', stiffness: 100, duration: 2 }}
        >
          {content.rightSide}
        </motion.div>
      </div>
    </div>
  )
}
